import { Link } from 'react-router-dom'
import type { FleetSubmitResult, AccountSummary } from '../../api/types'

interface Props {
  result: FleetSubmitResult
  accounts: AccountSummary[]
  onCancelAll?: () => void
  onDismiss?: () => void
}

export function StatusGrid({ result, accounts, onCancelAll, onDismiss }: Props) {
  return (
    <div className="border border-zinc-800 rounded-lg overflow-hidden">
      <div className="px-4 py-3 border-b border-zinc-800 flex items-center justify-between bg-zinc-950/60">
        <div>
          <div className="text-sm font-semibold text-zinc-100">Submitted</div>
          <div className="text-[11px] text-zinc-500 font-mono mt-0.5">
            parent_intent_id: <span className="text-zinc-400">{result.parentIntentId.slice(0, 12)}…</span>
          </div>
        </div>
        <div className="flex gap-2">
          <Link
            to={`/trades/${encodeURIComponent(result.parentIntentId)}`}
            className="px-3 py-1.5 text-xs rounded border border-emerald-700/60 bg-emerald-950/40 hover:bg-emerald-950/60 text-emerald-300 font-semibold"
          >
            View trade →
          </Link>
          {onCancelAll && (
            <button
              onClick={onCancelAll}
              className="px-3 py-1.5 text-xs rounded bg-rose-600 hover:bg-rose-500 text-white font-semibold"
            >
              Cancel all open
            </button>
          )}
          {onDismiss && (
            <button
              onClick={onDismiss}
              className="px-3 py-1.5 text-xs rounded border border-zinc-700 text-zinc-300 hover:bg-zinc-900"
            >
              Dismiss
            </button>
          )}
        </div>
      </div>
      <div>
        {result.children.map((c, i) => {
          const a = accounts.find(x => x.accountId === c.accountId)
          const dotCls =
            c.status === 'dispatched' ? 'bg-emerald-500 shadow-[0_0_6px_#10b981aa]'
          : c.status === 'failed'     ? 'bg-rose-500 shadow-[0_0_6px_#ef4444aa]'
          :                             'bg-zinc-500'
          const label =
            c.status === 'dispatched' ? <span className="text-emerald-400">Dispatched</span>
          : c.status === 'failed'     ? <span className="text-rose-400">Failed</span>
          :                             <span className="text-zinc-400">Skipped</span>
          return (
            <div key={c.eventId ?? `${i}`} className="px-4 py-3 border-b border-zinc-900 last:border-b-0 flex items-center gap-3">
              <span className={`w-[7px] h-[7px] rounded-full inline-block shrink-0 ${dotCls}`} />
              <div className="flex-1 min-w-0">
                <div className="text-sm text-zinc-100">
                  {a ? `${a.platformId} · ${a.accountId}` : (c.accountId ?? 'unknown account')}
                </div>
                <div className="text-[11px] text-zinc-500 font-mono mt-0.5 truncate">
                  {c.upstreamOrderId
                    ? `upstream: ${c.upstreamOrderId}`
                    : (c.reason ?? c.error ?? '')}
                </div>
              </div>
              <div className="text-sm">{label}</div>
            </div>
          )
        })}
      </div>
    </div>
  )
}
